import { useEffect, useRef } from "react"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom";
import { updateHeader } from "../../slices/header-slice";
import { useInView } from "framer-motion";

import Animate from '../../components/animate';

import './styles.scss';

const AdditionalServices = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const ref = useRef(null);
    const isInView = useInView(ref, { once: false, amount: 0.1 });

    useEffect(() => {
        if (isInView) {
            dispatch(updateHeader('transparent'))

        } else {
            dispatch(updateHeader('dark'))
        }
    }, [isInView, dispatch]);

    useEffect(() => {
        dispatch(updateHeader('transparent'))
    }, [dispatch]);

    return (
        <div className="additional-services">
            <div ref={ref} className="page-hero">
                <div className="hero-content">
                    <h1>Additional Services</h1>
                    <p>Workshop services like hand sanding, planing, and more.</p>
                </div>
            </div>

            <Animate>
                <div className="services-info">
                    <div className="services">
                        <div className="service">
                            <div className="service-title">
                                <h2>Wide Belt Sanding  |  CNC Flattening/Engraving  |  Refinishing</h2>
                            </div>
                            <div className="service-description">
                                <p>All additional services are charged at our day rate of $635 + tax. Minimum charge of 1 day. There is a one time $150 + tax setup fee for CNC work.</p>
                            </div>
                        </div>
                        <div className="service">
                            <div className="service-title">
                                <h2>Digital 3-D Renderings by our On-Staff Artist</h2>
                            </div>
                            <div className="service-description">
                                <p>Looking to get something custom made, but you want to see it come to life first? Our talented staff can create your dream as a 3-D Rendering. The cost for this is $1,000 + tax. Unlimited revisions to the design included. When you proceed to hire us to build it, we will apply half of the 3-D Rendering purchase to the final bill as credit.</p>
                            </div>
                        </div>
                    </div>
                    <button className="cta gold-fill" onClick={() => navigate("/contact")}>Request a quote</button>
                </div>
            </Animate>
        </div>
    )
}

export default AdditionalServices